import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTie } from '@fortawesome/free-solid-svg-icons';
import ThemeButton from './atoms/ThemeButton';
import SecondaryThemeButton from './atoms/SecondaryThemeButton';

const LogoutConfirmation = ({ isOpen, onConfirm, onClose }) => {
    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-lg" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white/90 p-8 text-center align-center shadow-2xl border border-primary/10 backdrop-blur-md transition-all">
                                <div className="flex flex-col items-center">
                                    <div className="text-white bg-primary rounded-full p-5 mb-4 shadow-lg flex items-center justify-center animate-bounce">
                                        <FontAwesomeIcon icon={faUserTie} className="text-4xl" />
                                    </div>

                                    <Dialog.Title as="h3" className="text-2xl font-extrabold text-primary mb-2 drop-shadow-sm">
                                        Are you sure you want to log out?
                                    </Dialog.Title>

                                    {/* Buttons */}
                                    <div className="flex justify-center space-x-4 w-full mt-6">
                                        <SecondaryThemeButton
                                            label="Stay"
                                            onClick={onClose}
                                            className="w-28  font-semibold "
                                        />
                                        <ThemeButton
                                            label="Log Out"
                                            onClick={onConfirm}
                                            className="w-32 py-2 font-semibold rounded-full shadow-md"
                                            primaryColor="bg-primary"
                                            secondaryColor="bg-red-500"
                                            textColor="#fff"
                                            hoverTextColor="#160033"
                                        />
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};

export default LogoutConfirmation;
